module.exports = __webpack_public_path__ + "img/img (45).c042870a.jpg";